"use client";

import { startTransition } from "react";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

import { setLocale } from "@/app/actions/set-locale";
import { locales, type Locale } from "@/i18n/config";
import { cn } from "@/lib/utils";

export function LocaleSwitcher({
  variant = "default",
}: {
  variant?: "default" | "header";
}) {
  const currentLocale = useLocale();
  const router = useRouter();
  const t = useTranslations("foundation.language");

  function selectLocale(locale: Locale) {
    if (locale === currentLocale) return;

    startTransition(async () => {
      await setLocale(locale);
      router.refresh();
    });
  }

  return (
    <div
      className={cn("flex", variant === "header" ? "gap-1" : "gap-2")}
      role="group"
      aria-label={t("label")}
    >
      {locales.map((locale) => {
        const selected = locale === currentLocale;

        return (
          <button
            key={locale}
            type="button"
            aria-pressed={selected}
            onClick={() => selectLocale(locale)}
            className={cn(
              "h-8 rounded-md border px-3 text-xs font-medium transition-colors disabled:cursor-default",
              variant === "header"
                ? "h-7 border-zinc-700 bg-zinc-950 px-2 text-zinc-300 hover:bg-zinc-800 hover:text-white disabled:border-zinc-500 disabled:bg-zinc-100 disabled:text-zinc-950"
                : "border-border bg-card text-foreground hover:bg-muted disabled:bg-primary disabled:text-primary-foreground",
            )}
            disabled={selected}
          >
            {t(locale)}
          </button>
        );
      })}
    </div>
  );
}
